import i18next from "i18next";
import en from "./en";
import km from "./km";

const params = new URLSearchParams(document.location.search);
let showDebuging = false;
let selectedLng = localStorage.getItem("LOCALE");
if (params.has("lang")) {
  selectedLng = params.get("lang");
}

if (process.env.REACT_APP_ENV === "DEV") {
  showDebuging = true;
}

i18next.init({
  resources: {
    en: {
      translation: en,
    },
    km: {
      translation: km,
    },
  },
  lng: selectedLng,
  fallbackLng: "en",
  debug: showDebuging,
});

export default i18next;
